// extracted by mini-css-extract-plugin
export default {"container":"styles_container__z4fT8","tab-children":"styles_tab-children__LUf0j","tab-children-error":"styles_tab-children-error__+5CUZ"};